var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBarLogOutOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_bar-log-out-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top_bar-log-out-over",
    fill: "#4E565A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5658537,17.0285714 C12.7902439,17.2285714 13.0426829,17.3142857 13.295122,17.3142857 C13.6036585,17.3142857 13.9121951,17.1714286 14.1365854,16.9142857 L17.6707317,12.7428571 C18.0353659,12.3142857 18.0353659,11.6857143 17.6707317,11.2571429 L14.1365854,7.08571429 C13.7439024,6.6 13.0146341,6.54285714 12.5658537,6.97142857 C12.0890244,7.37142857 12.0329268,8.11428571 12.4536585,8.57142857 L14.3890244,10.8571429 L7.29268293,10.8571429 C6.67560976,10.8571429 6.17073171,11.3714286 6.17073171,12 C6.17073171,12.6285714 6.67560976,13.1428571 7.29268293,13.1428571 L14.3890244,13.1428571 L12.4536585,15.4285714 C12.0329268,15.9142857 12.0890244,16.6285714 12.5658537,17.0285714 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7280488,8.31428571 C20.952439,8.88571429 21.6256098,9.17142857 22.1865854,8.94285714 C22.747561,8.71428571 23.0280488,8.02857143 22.8036585,7.45714286 C20.9804878,2.91428571 16.6890244,0 11.8926829,0 C5.38536585,0 0.112195122,5.37142857 0.112195122,12 C0.112195122,18.6285714 5.38536585,24 11.8926829,24 C16.6890244,24 20.9804878,21.0857143 22.8036585,16.5428571 C23.0280488,15.9714286 22.7756098,15.2857143 22.1865854,15.0571429 C21.6256098,14.8285714 20.952439,15.0857143 20.7280488,15.6857143 C19.2414634,19.3428571 15.7914634,21.7142857 11.8926829,21.7142857 C6.64756098,21.7142857 2.35609756,17.3428571 2.35609756,12 C2.35609756,6.65714286 6.64756098,2.28571429 11.8926829,2.28571429 C15.7914634,2.28571429 19.2414634,4.65714286 20.7280488,8.31428571 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBarLogOutOver);
export default __webpack_public_path__ + "static/media/top_bar-log-out-over.2538fefe0207c7ff9035c045f7aa0cc8.svg";
export { ForwardRef as ReactComponent };